'use strict';

exports.__esModule = true;
exports['default'] = normalize;

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
    var _ref;

    return [
        ((_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%',
            },
            body: {
                margin: '0',
            },
            main: {
                display: 'block',
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0',
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible',
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em',
            },
            a: {
                backgroundColor: 'transparent',
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline',
            },
        }),
        (_ref['b,\n    strong'] = {
            fontWeight: 'bolder',
        }),
        (_ref['code,\n    kbd,\n    samp'] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em',
        }),
        (_ref.small = {
            fontSize: '80%',
        }),
        (_ref['sub,\n    sup'] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline',
        }),
        (_ref.sub = {
            bottom: '-0.25em',
        }),
        (_ref.sup = {
            top: '-0.5em',
        }),
        (_ref.img = {
            borderStyle: 'none',
        }),
        (_ref['button,\n    input,\n    optgroup,\n    select,\n    textarea'] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0',
        }),
        (_ref['button,\n    input'] = {
            overflow: 'visible',
        }),
        (_ref['button,\n    select'] = {
            textTransform: 'none',
        }),
        (_ref['button,\n    html [type="button"],\n    [type="reset"],\n    [type="submit"]'] = {
            WebkitAppearance: 'button',
        }),
        (_ref[
            'button::-moz-focus-inner,\n    [type="button"]::-moz-focus-inner,\n    [type="reset"]::-moz-focus-inner,\n    [type="submit"]::-moz-focus-inner'
        ] = {
            borderStyle: 'none',
            padding: '0',
        }),
        (_ref[
            'button:-moz-focusring,\n    [type="button"]:-moz-focusring,\n    [type="reset"]:-moz-focusring,\n    [type="submit"]:-moz-focusring'
        ] = {
            outline: '1px dotted ButtonText',
        }),
        (_ref.fieldset = {
            padding: '0.35em 0.625em 0.75em',
        }),
        (_ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal',
        }),
        (_ref.progress = {
            verticalAlign: 'baseline',
        }),
        (_ref.textarea = {
            overflow: 'auto',
        }),
        (_ref['[type="checkbox"],\n    [type="radio"]'] = {
            boxSizing: 'border-box',
            padding: '0',
        }),
        (_ref[
            '[type="number"]::-webkit-inner-spin-button,\n    [type="number"]::-webkit-outer-spin-button'
        ] = {
            height: 'auto',
        }),
        (_ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px',
        }),
        (_ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none',
        }),
        (_ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit',
        }),
        (_ref.details = {
            display: 'block',
        }),
        (_ref.summary = {
            display: 'list-item',
        }),
        (_ref.template = {
            display: 'none',
        }),
        (_ref['[hidden]'] = {
            display: 'none',
        }),
        _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted',
            },
        },
    ];
}

module.exports = exports.default;
